import {
  Button,
  Stack,
  Typography,
  type AlertColor,
  type AlertPropsColorOverrides,
} from '@mui/material';
import { deleteCampaign } from '../fetchFns';
import useDialog from '../hooks/useDialog';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';
import type { OverridableStringUnion } from '@mui/types';

interface DeleteCampaignDialogProps {
  merchantId: number;
  campaignId: number;
  handleRemoveCampaign: (merchantId: number, campaignId: number) => void;
}

export default function DeleteCampaignDialog({
  merchantId,
  campaignId,
  handleRemoveCampaign,
}: DeleteCampaignDialogProps) {
  const backdrop = useBackdrop();
  const dialog = useDialog();
  const snackbar = useSnackbar();

  const handleDeleteCampaign = async () => {
    let message = 'The campaign has been deleted';
    let severity:
      | OverridableStringUnion<AlertColor, AlertPropsColorOverrides>
      | undefined = 'success';

    backdrop.handleBackdropOpen();
    try {
      await deleteCampaign(merchantId, campaignId);
      handleRemoveCampaign(merchantId, campaignId);
    } catch (error) {
      const errorCast = error as Error;
      message = errorCast.message;
      severity = 'error';
      console.error(errorCast.stack);
    }
    backdrop.handleBackdropClose();
    dialog.handleDialogClose();
    snackbar.handleSnackbarOpen(message, severity);
  };

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="body1">
        Are you sure you want to delete this campaign?
      </Typography>
      <Stack justifyContent="end" direction="row" spacing={2}>
        <Button
          onClick={() => {
            dialog.handleDialogClose();
          }}>
          Cancel
        </Button>
        <Button
          color="error"
          onClick={async () => {
            await handleDeleteCampaign();
          }}>
          Delete
        </Button>
      </Stack>
    </Stack>
  );
}
